
export const TvChannelCardShimmer: React.FC = () => (
    <div className="channel-category-list">
        <div className="channel-item-header text-rtl text-right text-rtl">
            <div className="channel-item-header-content shimmer"></div>
        </div>
    </div>
);